import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-account-events-card',
  templateUrl: './account-events-card.component.html',
  styleUrls: ['./account-events-card.component.scss']
})
export class AccountEventsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('events-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('events-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availableAlerts;
      this.disableCount = this.data.unavailableAlerts;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('events-counts-spinner');
    }
  }

}
